{
  "panel": {
    "title": "Bayanai",
    "newNote_title": "Sabon bayani",
    "search_placeholder": "Bincika bayanai…",
    "search_aria": "Bincika bayanai",
    "clearSearch_aria": "Share bincike",
    "editorPlaceholder": "Me ke cikin tunaninka…",
    "titleInput_placeholder": "Babu Take",
    "untitled": "Babu take",
    "emptyNote": "Bayani babu",
    "loadingNotes": "Ana lodin bayanai…",
    "noNotesYet": "Babu bayanai har yanzu. Danna + don ƙirƙirar ɗaya.",
    "noResults": "Babu sakamako don \"{{query}}\"",
    "noNotesTagged": "Babu bayanan da aka yi wa lakabin {{tag}}",
    "tagFilterAll": "Duka",
    "filterByTag_aria": "Tace ta lakabi",
    "templates": "Samfura",
    "editorTheme_aria": "Jigon edita",
    "themeActive_aria": "Jigon {{theme}} (mai aiki)",
    "theme_aria": "Jigon {{theme}}",
    "themeName": {
      "dark": "Duhu",
      "sepia": "Sepia",
      "light": "Haske",
      "forest": "Daji"
    },
    "voice": "Murya",
    "voice_title": "Bayanin murya",
    "voiceUnavailable_title": "Magana babu a wannan birawza",
    "openVoiceRecorder_aria": "Buɗe na'urar yin bayanin murya",
    "summarizing_title": "Ana taƙaitawa…",
    "summarize_title": "Taƙaita",
    "summarizeNote_aria": "Taƙaita bayani",
    "aiCommands_title": "Umarnin AI  Cmd+K",
    "openAiPalette_aria": "Buɗe allon umarnin AI",
    "enterFocusMode_title": "Yanayin maida hankali  Cmd+Shift+F",
    "exitFocusMode_title": "Fita yanayin maida hankali  Cmd+Shift+F",
    "enterFocusMode_aria": "Shiga yanayin maida hankali",
    "exitFocusMode_aria": "Fita yanayin maida hankali",
    "export_title": "Fitar da bayani",
    "delete_title": "Share bayani",
    "delete_aria": "Share bayani",
    "moreActions_title": "Ƙarin ayyuka",
    "wordCount_one": "kalma {{formatted}} · ~{{minutes}} min karatu",
    "wordCount_other": "kalmomi {{formatted}} · ~{{minutes}} min karatu",
    "referencedBy_one": "An yi nuni da shi sau {{count}}",
    "referencedBy_other": "An yi nuni da shi sau {{count}}",
    "noMatchingNotes": "Babu bayanan da suka dace",
    "mobileTabs_aria": "Kallon bayanai",
    "mobileTabNotes": "Bayanai",
    "mobileTabEditor": "Edita",
    "saveFailed": "An kasa ajiye bayani: {{message}}",
    "deleteFailed": "An kasa share bayani",
    "loadFailed": "An kasa lodin bayanai",
    "analyzeFailed": "An kasa nazarin bayani",
    "aiCommandFailed": "Umarnin AI ya kasa",
    "unknownError": "Kuskuren da ba a sani ba"
  },
  "paywall": {
    "title": "Bayanai wani ɓangare ne na Rhemn Pro",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "Buɗe bayanai masu daidaitawa, rubutu da murya na birawza, da taƙaitaccen AI mai tsari."
  },
  "format": {
    "bold": "Kauri",
    "italic": "Karkata",
    "strikethrough": "Layi a kai",
    "inlineCode": "Lamba a layi",
    "heading1": "Take 1",
    "heading2": "Take 2",
    "heading3": "Take 3",
    "bulletList": "Jeri mai ɗigo",
    "numberedList": "Jeri mai lamba",
    "blockquote": "Faɗar ƙididdiga",
    "codeBlock": "Toshen lamba",
    "toggleBold_aria": "Sauya kauri",
    "toggleItalic_aria": "Sauya karkata",
    "toggleStrikethrough_aria": "Sauya layi a kai",
    "toggleInlineCode_aria": "Sauya lamba a layi",
    "toggleBulletList_aria": "Sauya jeri mai ɗigo",
    "toggleNumberedList_aria": "Sauya jeri mai lamba",
    "toggleBlockquote_aria": "Sauya faɗar ƙididdiga",
    "formatOptions_aria": "Zaɓuɓɓukan tsari"
  },
  "analysis": {
    "heading": "Taƙaitawa",
    "onDevice": "⚡ A na'ura",
    "onDevice_aria": "An sarrafa a na'ura",
    "applyToNote_title": "Aiwatar a bayani",
    "applyToNote_aria": "Aiwatar da taƙaitawa a bayani",
    "summaryLabel": "Taƙaitawa",
    "keyPointsLabel": "Maɓallan Bayani",
    "noKeyPoints": "Babu maɓallan bayani da aka dawo da su don wannan bayani."
  },
  "export": {
    "markdown": "Fitar a matsayin Markdown",
    "plainText": "Fitar a matsayin Rubutu Mai Sauƙi",
    "pdf": "Fitar a matsayin PDF",
    "allZip": "Fitar duka a matsayin ZIP",
    "label": "Fitar"
  },
  "cmdk": {
    "dialog_aria": "Allon umarnin AI",
    "input_placeholder": "Tambayi AI ko gudanar da umarni…",
    "esc": "Esc",
    "back_aria": "Baya",
    "translateTo": "Fassara zuwa",
    "language_placeholder": "Harshe…",
    "aiActions": "Ayyukan AI",
    "noCommandsMatch": "Babu umarnin da suka dace da \"{{query}}\"",
    "continue": {
      "label": "Ci gaba da rubutu",
      "description": "Ci gaba daga inda ka tsaya"
    },
    "summarize": {
      "label": "Taƙaita zaɓi",
      "description": "Taƙaita zuwa maɓallan bayani"
    },
    "formal": {
      "label": "Sanya wannan na hukuma",
      "description": "Ɗaga sautin zuwa ƙwararru"
    },
    "simplify": {
      "label": "Sauƙaƙa",
      "description": "Harshe mai gajarta, mai sarari"
    },
    "translate": {
      "label": "Fassara zuwa…",
      "description": "Fassara zuwa wani harshe"
    },
    "expand": {
      "label": "Faɗaɗa wannan ɗigo",
      "description": "Faɗaɗa ɗigon da aka zaɓa zuwa rubutu"
    },
    "languages": {
      "Spanish": "Sifaniyanci",
      "Arabic": "Larabci",
      "French": "Faransanci",
      "German": "Jamusanci",
      "Japanese": "Jafananci",
      "Portuguese": "Portugaliyanci"
    }
  },
  "templates": {
    "dialog_aria": "Zaɓi samfuri",
    "header": "Zaɓi Samfuri",
    "builtInLabel": "Na ciki",
    "myTemplatesLabel": "Samfurana",
    "saveCurrent": "Ajiye bayanin yanzu a matsayin samfuri",
    "myTemplatesEmpty": "Samfuran da ka ajiye za su bayyana a nan",
    "useTemplate": "Yi amfani da Samfuri",
    "meeting": {
      "name": "Bayanan Taro",
      "description": "Tattara yanke shawara da abubuwan da za a yi",
      "structure": "Mahalarta / Ajanda / Bayanai / Ayyuka"
    },
    "journal": {
      "name": "Littafin Yini",
      "description": "Yi tunani a kan ranarka",
      "structure": "Godiya / Nasarorin yau / Bayanai"
    },
    "book": {
      "name": "Taƙaitaccen Littafi",
      "description": "Tattara maɓallan ra'ayoyi daga littafi",
      "structure": "Babban ra'ayi / Maɓallan faɗi / Abubuwan koyo"
    },
    "project": {
      "name": "Taƙaitaccen Aikin",
      "description": "Bayyana iyaka, manufofi, da masu ruwa da tsaki",
      "structure": "Manufa / Iyaka / Haɗari / Lokaci"
    },
    "brainstorm": {
      "name": "Tunani",
      "description": "Tattara ra'ayoyi cikin 'yanci",
      "structure": "Jigo / Ra'ayoyi / Matakai na gaba"
    },
    "weekly": {
      "name": "Bita ta Mako",
      "description": "Yi bita da tsara makonka",
      "structure": "Nasarori / Wahalhalu / Wuraren maida hankali"
    }
  },
  "voice": {
    "dialog_aria": "Na'urar yin bayanin murya",
    "cancel_aria": "Soke",
    "statusRecording": "Ana ɗauka",
    "statusTranscribing": "Ana rubutawa…",
    "statusReview": "Bita",
    "skip": "Tsallake",
    "mark": "Yi alama",
    "mark_title": "Saka alamar lokaci",
    "captureMeeting": "Ɗauki taro",
    "captureMeeting_title": "Hakanan ɗauki sauti daga shafin taro",
    "meeting": "Taro",
    "meeting_title": "Ana ɗaukar shafin taro",
    "markers_aria": "Alamomin lokaci",
    "listening": "Ana saurara…",
    "micDenied": "An kashe izinin makirufo. Ba da izini a Saituna, sannan a sake gwadawa.",
    "captureFailed": "Ba a iya fara rikodin ba. A sake gwadawa nan da ɗan lokaci.",
    "tabPicker_aria": "Zaɓi shafin taro don ɗauka",
    "captureFrom": "Ɗauki sauti daga…",
    "noAudibleTab": "Babu shafin da ke kunna sauti. Buɗe taronka kuma tabbatar wani yana magana, sa'an nan sake gwadawa.",
    "tabPickerCancel": "Soke",
    "tabTranscript": "Rubutaccen magana",
    "structuring": "Ana tsarawa…",
    "structuredNote": "Bayani Mai Tsari",
    "structureFailed": "An kasa ƙirƙirar bayanin da aka tsara.",
    "retryStructure": "Sake gwadawa",
    "browserTranscript": "Rubutaccen birawza",
    "nothingCaptured": "Ba a ɗauki komai ba.",
    "buildingStructured": "Ana gina bayani mai tsari…",
    "cancel": "Soke",
    "stop": "Tsaya",
    "recordAgain": "Sake ɗauka",
    "saveToNote": "Ajiye a Bayani",
    "statusMeeting": "Taro",
    "captureStrip_aria": "Ana ɗaukar sauti daga {{tab}}",
    "stopCapture": "Dakatar da ɗauka",
    "stopCapture_title": "Dakatar da ɗaukar shafin — makirufo na ci gaba da rikodi",
    "stopsIn": "Zai tsaya cikin {{time}}",
    "autoStopped": "Rikodin ya tsaya a iyakar minti 60.",
    "autoStoppedQuota": "Rikodin ya tsaya — ka yi amfani da mintunan rubutawa na wannan wata.",
    "captureLost": "Shafin taron ya rufe. Makirufonka na ci gaba da rikodi.",
    "tabSummary": "Taƙaitawa",
    "noSpeakers": "Ba a gane masu magana ba",
    "speakerN": "Mai magana {{number}}",
    "renameSpeaker_aria": "Canza sunan {{name}} — zai shafi dukan layukansa",
    "renameSpeaker_input_aria": "Sunan mai magana",
    "turnTime_title": "An faɗa a {{time}}",
    "actionItemsTitle": "Ayyukan da za a yi",
    "actionsCount": "{{checked}} daga {{total}}",
    "addToTasks_one": "Ƙara {{count}} zuwa Ayyuka",
    "addToTasks_other": "Ƙara {{count}} zuwa Ayyuka",
    "addToTasksZero": "Ƙara zuwa Ayyuka",
    "adding": "Ana ƙarawa…",
    "tasksAdded_one": "An ƙara aiki {{count}}",
    "tasksAdded_other": "An ƙara ayyuka {{count}}",
    "viewTasks": "Duba",
    "addFailed": "Ba a iya ƙarawa ba — sake gwadawa.",
    "minutesLeft_one": "Minti {{count}} ya rage",
    "minutesLeft_other": "Mintuna {{count}} sun rage",
    "minutesLeftShort_one": "Minti {{count}} ya rage",
    "minutesLeftShort_other": "Mintuna {{count}} sun rage",
    "minutesLeft_title": "Mintunan rubutawa {{count}} sun rage a wannan wata",
    "quotaExhausted": "Ka yi amfani da mintunan taro na wannan wata. Za su sabunta a {{date}}.",
    "quotaUnknown": "Ba a san sauran mintuna ba — rikodin na iya kaiwa iyakar wata",
    "meetingProRequired": "Rubutawar taro na cikin Pro. An adana rubutunka kai tsaye a ƙasa.",
    "gateTitle": "Rikodin taro",
    "gateBody": "Yi rikodin shafin taro tare da makirufonka — da gane masu magana da fitar da ayyuka. Yana tare da Pro.",
    "gateLater": "Ba yanzu ba",
    "gateCta": "Duba Pro",
    "roomOption": "Babu shafi — yi rikodin ɗakin",
    "roomHint": "Kira a lasifika, wata manhaja ta daban, ko mutane a cikin ɗakin — duk abin da za ka iya ji da ƙara.",
    "roomHint_title": "Idan ɗayan yana cikin belun kunnenka, makirufo ba zai ji shi ba — yi amfani da lasifika.",
    "recordRoom": "Yi rikodin ɗakin",
    "recordRoom_title": "Yi rikodin duk wanda makirufo ke ji — da gane masu magana",
    "roomStart": "Fara",
    "statusRoom": "Ɗaki",
    "roomStrip": "Ana rikodin ɗakin",
    "roomStrip_aria": "Ana rikodin ɗakin — duk wanda makirufo ke ji",
    "roomOff": "Kashe",
    "roomOff_title": "Kashe yanayin ɗaki — wannan zai koma bayanin murya na yau da kullum",
    "roomRenameHint": "Danna suna don canza shi — ɗaya daga cikin waɗannan kai ne.",
    "gateBodyRoom": "Yi rikodin abin da ake faɗa kewaye da kai — da gane masu magana da fitar da ayyuka. Yana tare da Pro.",
    "roomHintDevice": "Ba za a iya yin rikodin kiran wannan na'urar ba — iOS na kiyaye sirrinsu. Wata wayar daban a lasifika, ko tattaunawa a cikin ɗakin, na aiki.",
    "autoStoppedSize": "Rikodin ya tsaya a iyakar girman lodawa.",
    "tooLarge": "Rikodin ya yi girma da yawa don lodawa, don haka ba a iya rubuta shi ba.",
    "destTo": "Zuwa",
    "dest_aria": "Ƙara zuwa jerin: {{name}}",
    "destMenu_aria": "Zaɓi jeri",
    "destNewPending_aria": "Sabon jeri: {{name}}"
  },
  "meetingNotice": {
    "title": "Tarurruka, cikin bayanan ka",
    "body": "Yanzu Rhemn na iya yin rikodin shafin taro da ka zaɓa — kawai lokacin da kake rikodin bayanin murya, kuma kawai shafin da ka zaɓa.",
    "factPrivacy": "Ana sarrafa sautin don ƙirƙirar rubutunka, sannan a zubar da shi. Ba a taɓa adana rikodin ba.",
    "factControl": "Ba a ɗaukar komai sai ka danna rikodi ka zaɓi shafi.",
    "cta": "Na gane",
    "privacyLink": "Karanta manufofin sirrinmu",
    "dialog_aria": "Game da sabuwar izinin rikodin taro"
  }
}
